<template>
  <div>
    <iframe :id="id" :ref="`vimeo-video-${id}`" width="100%" height="450" :src="`${urlVideo}`" frameborder="0" class="video-tracking"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
  </div>
</template>

<script>
import Player from '@vimeo/player'
import VideosAPI from '@/api/videos-api'
import Utils from '@/core/utils/utils'

export default {
  name: 'VimeoPlayer',
  props: {
    id: Number,
    ementaId: Number,
    tipoOrigemId: Number,
    urlVideo: String,
    inicio: Number
  },

  data () {
    return {
      player: null,
      playing: false
    }
  },

  beforeDestroy () {
    try {
      this.player.unload()
    } catch (error) {
      this.error = error
    }
    clearInterval(this.intervalId)
  },

  mounted () {
    this.player = new Player(this.$refs[`vimeo-video-${this.id}`])

    this.$nextTick(async () => {
      const tempoTotalVideo = await this.player.getDuration()
      let inicio = this.inicio
      if (tempoTotalVideo === Math.floor(this.inicio)) {
        inicio -= 5
      }
      if (this.inicio && this.inicio > 0) {
        if (tempoTotalVideo < Math.floor(this.inicio)) {
          this.player.setCurrentTime(0)
        } else {
          this.player.setCurrentTime(Math.floor(inicio))
        }
      }

      this.player.on('pause', () => {
        this.player.getCurrentTime().then(seconds => {
          if (this.inicio !== seconds) {
            VideosAPI.atualizarTempoVideo(this.ementaId, seconds)
          }
          this.playing = false
        })
      })

      this.player.on('ended', () => {
        this.player.getCurrentTime().then(seconds => {
          if (this.inicio !== seconds) {
            VideosAPI.atualizarTempoVideo(this.ementaId, seconds)
          }
        })
        this.autoplayVideo()
        this.playing = false
      })
    })

    this.intervalId = setInterval(() => {
      this.concluiVideo()
    }, 3000)
  },

  computed: {
    autoplay: function () {
      return JSON.parse(localStorage.getItem('autoplay'))
    },

    controleTopico: function () {
      return this.$store.getters.getControleTopico
    }
  },

  watch: {
    videoId: 'update',

    inicio: function () {
      this.$nextTick(async () => {
        const tempoTotalVideo = await this.player.getDuration()
        let inicio = this.inicio
        if (tempoTotalVideo === Math.floor(this.inicio)) {
          inicio -= 5
        }
        if (this.inicio && this.inicio > 0) {
          if (tempoTotalVideo < this.inicio) {
            this.player.setCurrentTime(0)
          } else {
            this.player.setCurrentTime(Math.floor(inicio))
          }
        }
      })
    }
  },

  methods: {
    update (videoId) {
      return this.player.loadVideo(videoId)
    },

    play: async function () {
      await Utils.sleep(150)
      this.player.play()
      this.playing = true
    },

    pause: function () {
      if (!this.player.paused && this.playing) {
        this.player.pause()
      }
    },

    autoplayVideo () {
      if (this.autoplay) {
        window.eventBus.$emit('salvarAnotacao')
        window.eventBus.$on('anotacaoSalva', async () => {
          await this.$store.dispatch('iniciaTimer', 5)
          this.$router.push(this.controleTopico.proximo.url)
        })
      }
    },

    async concluiVideo () {
      this.tempoAtualVideo = await this.player.getCurrentTime()
      this.tempoTotalVideo = await this.player.getDuration()
      this.$store.dispatch('concluiEmentaVideo', { ementaId: this.ementaId, tempoAtual: this.tempoAtualVideo, tempoTotal: this.tempoTotalVideo })
    }
  }
}
</script>

<style scoped>

</style>
